// extracted by mini-css-extract-plugin
module.exports = {"accordionSectionContainer":"_2_pHOf68"};